/* Rovina clone: lightweight scroll-snap slider (<clone-slider>) + inline video cards (<clone-video-card>) */
if (!customElements.get('clone-slider')) {
  customElements.define(
    'clone-slider',
    class CloneSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');
        this.dots = this.querySelector('[data-slider-dots]');
        this.items = Array.from(this.track.children);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        if (this.dots) this.buildDots();
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update());
        this.update();
      }

      step() {
        const first = this.items[0];
        if (!first) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      pages() {
        const perView = Math.max(1, Math.round(this.track.clientWidth / this.step()));
        return Math.max(1, this.items.length - perView + 1);
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      buildDots() {
        this.dots.innerHTML = '';
        const count = this.pages();
        for (let i = 0; i < count; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'clone-slider__dot';
          b.setAttribute('aria-label', `Slide ${i + 1}`);
          b.addEventListener('click', () => this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' }));
          this.dots.appendChild(b);
        }
      }

      update() {
        const index = Math.round(this.track.scrollLeft / this.step());
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        if (this.dots) {
          if (this.dots.children.length !== this.pages()) this.buildDots();
          Array.from(this.dots.children).forEach((d, i) => d.classList.toggle('is-active', i === index));
        }
      }
    }
  );
}

if (!customElements.get('clone-video-card')) {
  customElements.define(
    'clone-video-card',
    class CloneVideoCard extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.play = this.querySelector('[data-video-play]');
        this.sound = this.querySelector('[data-video-sound]');
        if (!this.video) return;
        if (this.play) this.play.addEventListener('click', () => this.toggle());
        this.video.addEventListener('click', () => this.toggle());
        if (this.sound)
          this.sound.addEventListener('click', (e) => {
            e.stopPropagation();
            this.video.muted = !this.video.muted;
            this.classList.toggle('is-unmuted', !this.video.muted);
          });
        this.video.addEventListener('ended', () => this.classList.remove('is-playing'));
      }

      toggle() {
        if (this.video.paused) {
          document.querySelectorAll('clone-video-card.is-playing').forEach((card) => {
            if (card !== this) card.pause();
          });
          this.video.play();
          this.classList.add('is-playing');
        } else {
          this.pause();
        }
      }

      pause() {
        this.video.pause();
        this.classList.remove('is-playing');
      }
    }
  );
}
